var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-search-map-container"},[_c('tabs',{attrs:{"activeTab":0,"tabs":_vm.tabs,"center-tabs":false,"tabs-styling":_vm.tabsStyling,"tabs-labels-styling":_vm.tabsLabelsStyling}}),_vm._v(" "),_c('management-map',{style:({ 'height': 'calc(100% - 50px)'})})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75d6c0e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/WorkspacesManagement/GlobalSearch/GlobalSearchMap.vue
// module id = null
// module chunks = 